module.exports = __webpack_public_path__ + "static/media/stripe-logo.869e7d46.png";